import styles from './dialog.module.scss';

interface Props {
    onClick?: () => void;
    title?: string; // optional native tooltip
}

export function InfoIcon({ onClick, title }: Props) {
    const clickable = !!onClick;

    return (
        <span
            className={`${styles.icon} ${clickable ? styles.clickable : ''}`}
            onClick={onClick}
            title={title}
        >
            i
        </span>
    );
}